<template>
  <b-col class="d-flex flex-column">
    <b-form class="guard-form">
      <b-row>
        <b-col
          v-for="(voltageColumnName, index) in voltageColumnsNames"
          :key="`${voltageColumnName}${index}`"
        >
          <span>{{ voltageColumnName }}</span>
        </b-col>
      </b-row>
      <b-row
        v-for="(voltageProbe, probeNumber) in guardForm.voltageProbes"
        :key="`voltageProbe${probeNumber}${voltageProbe}`"
        class="mb-0 mt-2"
      >
        <b-form-group class="mb-0 col-4">
          <b-form-input class="form-input" :value="probeNumber" name="project-code" disabled />
        </b-form-group>
        <b-form-group class="mb-0 col-4">
          <b-form-input
            v-model="guardForm.voltageProbes[probeNumber].connectionPoint"
            class="form-input"
            name="connection-point"
          />
        </b-form-group>
        <b-form-group class="mb-0 col-4">
          <b-form-select
            v-model="guardForm.voltageProbes[probeNumber].phase"
            class="form-select"
            :options="phaseOptions"
            name="voltage-phase"
          />
        </b-form-group>
      </b-row>
      <b-row class="mt-3">
        <b-col
          v-for="(currentColumnName, index) in currentColumnsNames"
          :key="`${currentColumnName}${index}`"
        >
          <span>{{ currentColumnName }}</span>
        </b-col>
      </b-row>
      <b-row
        v-for="(currentProbe, probeNumber) in guardForm.currentProbes"
        :key="`currentProbe${probeNumber}${currentProbe}`"
        class="mb-0 mt-2"
      >
        <b-form-group class="mb-0 col-4">
          <b-form-input class="form-input" :value="probeNumber" name="project-code" disabled />
        </b-form-group>
        <b-form-group class="mb-0 col-4">
          <b-form-input
            v-model="guardForm.currentProbes[probeNumber].feederName"
            class="form-input"
            name="feeder-name"
          />
        </b-form-group>
        <b-form-group class="mb-0 col-4">
          <b-form-select
            v-model="guardForm.currentProbes[probeNumber].phase"
            class="form-select"
            :options="phaseOptions"
            name="current-phase"
          />
        </b-form-group>
      </b-row>
      <b-row class="mt-3 justify-content-end">
        <b-button variant="rounded" @click="cancel">Cancel</b-button>
        <b-button variant="rounded" :disabled="didNotChange" @click="submit">Submit</b-button>
      </b-row>
    </b-form>
  </b-col>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import {
  VOLTAGE_COLUMNS_NAMES,
  CURRENT_COLUMNS_NAMES
} from '@/components/shared/device-events-consts';

const PHASE_OPTIONS_ARRAY = [
  { value: null, text: 'Not Used' },
  { value: 0, text: 'N' },
  { value: 1, text: 'L1' },
  { value: 2, text: 'L2' },
  { value: 3, text: 'L3' }
];

export default {
  name: 'EditGuardTableForm',
  props: {
    guardProbes: {
      currentProbes: Object,
      voltageProbes: Object
    }
  },
  data() {
    return {
      voltageColumnsNames: VOLTAGE_COLUMNS_NAMES,
      currentColumnsNames: CURRENT_COLUMNS_NAMES,
      phaseOptions: PHASE_OPTIONS_ARRAY,
      guardForm: cloneDeep(this.guardProbes)
    };
  },
  computed: {
    didNotChange() {
      return isEqual(this.guardProbes, this.guardForm);
    }
  },
  watch: {
    guardProbes: {
      handler() {
        this.guardForm = cloneDeep(this.guardProbes);
      },
      immediate: true
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.guardForm);
    },
    cancel() {
      this.resetInputs();

      this.$emit('hide');
    },
    resetInputs() {
      this.guardForm = cloneDeep(this.guardProbes);
    }
  }
};
</script>
